import { Component, Input, Output, EventEmitter } from "@angular/core";
import { FormControl } from "@angular/forms";
@Component({
  selector: "app-input-radio",
  templateUrl: "./input-radio.component.html",
  styleUrl: "./input-radio.component.scss",
})
export class InputRadioComponent {
  @Input() multipleSelections: boolean = false;
  @Input() label: string = "";
  @Input() options: { text: string; value: any }[] = [];
  @Input() control: FormControl = new FormControl();
  @Output() checkedChange = new EventEmitter<any>();

  updateControl(value) {
    this.control.setValue(value);
    this.checkedChange.emit();
  }
}
